import { useTranslation } from 'react-i18next';
import { fmtMoney, fmtDate } from '@/lib/enums';

/** Detalhamento de uma fatura (linhas + resumo). Usado pelo admin e pelo personal. */
export default function InvoiceDetail({ invoice }) {
  const { t } = useTranslation();
  if (!invoice) return null;

  const row = {
    display: 'flex',
    alignItems: 'baseline',
    gap: 12,
    padding: '10px 0',
    borderBottom: '1px solid var(--line)',
    fontSize: 13.5,
  };

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 16 }}>
        {[
          { label: t('invoices.colStudents'), value: invoice.studentCount },
          { label: t('invoices.colSales'), value: invoice.packagesSold },
          { label: t('invoices.colDue'), value: fmtDate(invoice.dueDate) },
        ].map((s) => (
          <div key={s.label} style={{ background: 'var(--surf2)', borderRadius: 10, padding: '10px 12px' }}>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 9, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--low)' }}>
              {s.label}
            </div>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, color: 'var(--hi)', marginTop: 4 }}>
              {s.value}
            </div>
          </div>
        ))}
      </div>

      <div className="kicker" style={{ marginBottom: 6 }}>{t('invoices.itemsTitle')}</div>
      {(invoice.items || []).map((item, i) => (
        <div key={i} style={row}>
          <span style={{ flex: 1, color: 'var(--hi)' }}>{item.label}</span>
          <span style={{ color: 'var(--mid)', fontSize: 12 }}>x{item.quantity}</span>
          <span style={{ fontWeight: 600, color: 'var(--hi)', minWidth: 90, textAlign: 'right' }}>{fmtMoney(item.amount)}</span>
        </div>
      ))}

      <div style={{ ...row, borderBottom: 'none', marginTop: 4 }}>
        <span style={{ flex: 1, fontFamily: 'var(--font-display)', fontWeight: 700, textTransform: 'uppercase', color: 'var(--hi)' }}>
          {t('invoices.totalDue')}
        </span>
        <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 20, color: 'var(--volt)' }}>
          {fmtMoney(invoice.totalAmount)}
        </span>
      </div>
    </div>
  );
}
